// services/lura-sign-user.service.ts
import axios from 'axios';
import { LuraSignUserData } from 'src/ts/interfaces/user/lura-sign-user-data';

export interface CreateLuraSignUserParams {
  email: string;
  phone?: string;
  tutorFullName: string;
  tutorCountryId: string;
  zohoId?: string;
}

export const createLuraSignUserService = async (params: CreateLuraSignUserParams) => {
  const url = `/users/create-lura-sign-user`;
  try {
    const response = await axios.post(url, params);
    console.log('RESPONSE IN CREATE LURA SIGN USER ', response.data.data)
    const luraSignUserData: LuraSignUserData = response.data.data;
    return luraSignUserData;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message);
  }
};